import { render, staticRenderFns } from "./addFoucusStrategy.vue?vue&type=template&id=640831c5&"
import script from "./addFoucusStrategy.vue?vue&type=script&lang=js&"
export * from "./addFoucusStrategy.vue?vue&type=script&lang=js&"
import style0 from "./addFoucusStrategy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports